import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { set } from 'date-fns/fp';
import { isExpired, decodeToken } from "react-jwt";

const products = [
  { name: 'Product 1', desc: 'A nice thing', price: '$9.99' },
  { name: 'Product 2', desc: 'Another thing', price: '$3.45' },
  { name: 'Product 3', desc: 'Something else', price: '$6.51' },
  { name: 'Product 4', desc: 'Best thing of all', price: '$14.11' },
  { name: 'Shipping', desc: '', price: 'Free' },
];
const addresses = ['1 Material-UI Drive', 'Reactville', 'Anytown', '99999', 'USA'];
const payments = [
  { name: 'Card type', detail: 'Visa' },
  { name: 'Card holder', detail: 'Mr John Smith' },
  { name: 'Card number', detail: 'xxxx-xxxx-xxxx-1234' },
  { name: 'Expiry date', detail: '04/2024' },
];

const useStyles = makeStyles((theme) => ({
  listItem: {
    padding: theme.spacing(1, 0),
  },
  total: {
    fontWeight: 700,
  },
  title: {
    marginTop: theme.spacing(2),
  },
}));


var totalProducto = 0;
var totaliva = 0;
var totalINC = 0;
var totalyIVa = 0;
var cont = 0;
var numproductos = 0;
var taxExclusiveAmount = 0;
var formatter = formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'COP',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export default function Review() {
    const classes = useStyles();

    //handle Observaciones
    const handleObservaciones = (selectedOption) => {
        localStorage.setItem('observaciones', selectedOption.target.value);
        console.log(localStorage.getItem('observaciones'));
    };

    useEffect(() => {
        cargarTotales();
        var moneda = localStorage.getItem('moneda');

        const formatterCurrency = (moneda) => {
            if (moneda == "COP") {
                console.log("COP");
                formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'COP',

                    // These options are needed to round to whole numbers if that's what you want.
                    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
                });
            }
            else {
                console.log("USD");
                formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',

                    // These options are needed to round to whole numbers if that's what you want.
                    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
                });
            }
        }
        formatterCurrency(moneda);
    }, []);

    const cargarTotales = () => {

        var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }

        console.log("Entr�");

        var productosdetalle = localStorage.getItem('productos');
        var datos = JSON.parse(productosdetalle);

        numproductos = datos.length;

        totalProducto = 0;
        var iva = 0;
        var inc = 0
        totaliva = 0;
        totalINC = 0;
        taxExclusiveAmount = 0;
        for (var i = 0; i < datos.length; i++) {
            totalProducto += datos[i].ValorUnitario * datos[i].Cantidad;
            var tipoi = parseInt(datos[i].TipoImpuesto);
            console.log(tipoi);
            if (tipoi === 0) {
                iva = ((datos[i].ValorUnitario * datos[i].Cantidad) * (datos[i].PorIVAProducto) / 100);
                var totalsiniva = datos[i].ValorUnitario - iva;
                totaliva += iva;
                console.log("fue iva");
                taxExclusiveAmount += datos[i].ValorUnitario * datos[i].Cantidad; //WLM
            } else if (tipoi === 1) {
                inc = ((datos[i].ValorUnitario * datos[i].Cantidad) * (datos[i].PorIVAProducto) / 100);
                totalINC += inc;
                console.log("fue imp");
                console.log(totalINC);
                taxExclusiveAmount += datos[i].ValorUnitario * datos[i].Cantidad; //WLM
            } else if (tipoi === 2) {
                 console.log("N/A");
            }
         }
        totalyIVa = Math.round((totalProducto + totaliva + totalINC) * 100) / 100;

        localStorage.setItem('totalLineas', numproductos);
        console.log(numproductos);
        setLiquidacion({
            lineas: numproductos,
            subtotal: totalProducto,
            totalIva: totaliva,
            totalInc: totalINC,
            total: totalyIVa,
        });
        localStorage.setItem('subtotal', totalProducto);
        console.log(totalProducto);
        localStorage.setItem('totalIVA', totaliva);
        localStorage.setItem('totalINC', totalINC);
        localStorage.setItem('BCD', taxExclusiveAmount);//WLM
        localStorage.setItem('BCDI', totalyIVa);
        localStorage.setItem('totalPagar', totalyIVa);
    } 

    const [liquidacion, setLiquidacion] = React.useState({
        lineas: numproductos,
        subtotal: totalProducto,
        totalIva: totaliva,
        totalInc: totalINC,
        total: totalyIVa,
    });  

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Totales
      </Typography>
      <List disablePadding>
        <ListItem className={classes.listItem}>
          <ListItemText primary="Total de Lineas:" />
                  <Typography variant="body2">
                      {liquidacion.lineas}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <ListItemText primary="Subtotal:" />
                  <Typography variant="body2">
                      {formatter.format(liquidacion.subtotal)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <ListItemText primary="Total IVA:" />
          <Typography variant="body2">
                      {formatter.format(liquidacion.totalIva)}
          </Typography>
              </ListItem>
              <ListItem className={classes.listItem}>
                  <ListItemText primary="Total de Ipoconsumo Nacional:" />
                  <Typography variant="body2">
                      {formatter.format(liquidacion.totalInc)}
                  </Typography>
              </ListItem>
        <ListItem className={classes.listItem}>
          <ListItemText primary="Base + Cargos - Descuentos:" />
          <Typography variant="body2">
                      {formatter.format(liquidacion.subtotal)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <ListItemText primary="Base + Cargos - Descuentos + Impuestos:" />
                  <Typography variant="body2">
                      {formatter.format(liquidacion.total)}
          </Typography>
         </ListItem>
        <ListItem className={classes.listItem}>
          <ListItemText primary="Total a pagar:" />
                  <Typography variant="subtitle1" className={classes.total}>
                      {formatter.format(liquidacion.total)}
          </Typography>
        </ListItem>
        
      </List>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
        <TextField
                      id="outlined-multiline-static"
                      multiline
                      rows={3}
                      label="Observaciones"
                      helperText="Escriba observaciones para la factura"
                      fullWidth
                      autoComplete="cc-csc"
                      variant="outlined"
                      onChange={handleObservaciones}
          />
        </Grid>
        <Grid item container direction="column" xs={12} sm={6}>
          {/*<Typography variant="h6" gutterBottom className={classes.title}>
            Payment details
          </Typography>
          <Grid container>
            {payments.map((payment) => (
              <React.Fragment key={payment.name}>
                <Grid item xs={6}>
                  <Typography gutterBottom>{payment.name}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography gutterBottom>{payment.detail}</Typography>
                </Grid>
              </React.Fragment>
            ))}
            </Grid>*/}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
